import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';

import {
    IconExternal,
    Menu,
    MenuItem,
    MenuPopper,
} from '@zillow/constellation';

import StringConstants from 'app/shared/constants/StringConstants';
import PropertyConstants from 'app/shared/constants/PropertyConstants';

import { StyledDisabledMenuItem, StyledTextButton } from './StyledComponents';

const propTypes = {
    syndication: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
};

const ConnectedNetworkView = forwardRef((props, ref) => {
    const { syndication, label } = props;
    const syndicationByBrand = [
        StringConstants.UNFORMATTED_BRAND_NAMES.zillow,
        StringConstants.UNFORMATTED_BRAND_NAMES.trulia,
        StringConstants.UNFORMATTED_BRAND_NAMES.hotpads,
    ];

    const menu = (
        <Menu className="ConnectedNetworkView" ref={ref} {...props}>
            {syndicationByBrand.map((brand) => {
                if (syndication[brand].status === PropertyConstants.LISTING_STATUS.POSTED) {
                    return (
                        <MenuItem
                            key={`menu-item-${brand}`}
                            as="a"
                            target="_blank"
                            href={syndication[brand].url}
                            icon={<IconExternal />}
                        >
                            {`View on ${capitalize(brand)}`}
                        </MenuItem>
                    );
                }
                return (
                    <StyledDisabledMenuItem key={`menu-item-${brand}`} icon={<IconExternal />}>
                        {`View on ${capitalize(brand)}`}
                    </StyledDisabledMenuItem>
                );
            })}
        </Menu>
    );

    return (
        <MenuPopper triggered={menu}>
            <StyledTextButton>{label}</StyledTextButton>
        </MenuPopper>
    );
});

ConnectedNetworkView.propTypes = propTypes;

export default ConnectedNetworkView;
